/* eslint-disable react/prop-types */
import React from 'react';
import { Stack, Typography, Divider, Tooltip } from '@mui/material';

export default function DetailRow({ label, value, noDivider = false }) {
  return (
    <>
      <Stack
        direction="row"
        sx={{
          justifyContent: 'space-between',
          alignItems: 'center',
          py: 1.5,
          px: 0.5,
          gap: 1,
        }}
      >
        <Typography
          sx={{
            color: '#637381',
            fontWeight: 500,
            fontSize: '13px',
            flexShrink: 0,
            minWidth: '110px',
          }}
        >
          {label}
        </Typography>
        {typeof value === 'string' || typeof value === 'number' ? (
          <Tooltip title={value} placement="top" arrow enterDelay={500}>
            <Typography
              noWrap
              sx={{
                color: '#212B36',
                fontWeight: 600,
                fontSize: '13px',
                textAlign: 'end',
                maxWidth: '180px',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                cursor: 'default',
              }}
            >
              {value}
            </Typography>
          </Tooltip>
        ) : (
          value
        )}
      </Stack>
      {!noDivider && <Divider sx={{ borderColor: '#F4F6F8', borderStyle: 'dashed' }} />}
    </>
  );
}
